import React, { useState } from 'react';
import {
  PaymentElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

import Button from '../shared/button.jsx';
import ProgressLogo from './progresslogo.jsx';
import { getAmountWithFees, formatMoney } from './shared.js';

export default function StripeForm(props) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/donate/newsletters`,
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === 'card_error') {
      setMessage(error.message);
    } else if (error.type === 'validation_error') {
      // These are displayed in the stripe UI.
    } else {
      setMessage(`An unexpected error occurred. ${error.message}`);
    }

    setIsLoading(false);
  };

  const getButtonText = function () {
    const amountString = formatMoney(
      getAmountWithFees(props.amount, props.coverFees)
    );
    let text = `Contribute $${amountString}`;

    if (props.frequency !== 'Once') {
      text += ' ' + props.frequency;
    }

    return text;
  };

  const stripeOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
    },
    defaultValues: {
      billingDetails: {
        name: `${props.contactInfo.firstName} ${props.contactInfo.lastName}`,
        email: props.contactInfo.email,
        phone: props.contactInfo.phone,
        address: {
          line1: props.contactInfo.address1,
          line2: props.contactInfo.address2,
          country: props.contactInfo.country,
          state: props.contactInfo.state,
          city: props.contactInfo.city,
          postal_code: props.contactInfo.zip,
        },
      },
    },
  };

  return (
    <form id="payment-form">
      <PaymentElement id="payment-element" options={stripeOptions} />
      <Button
        className="review-button"
        disabled={isLoading || !stripe || !elements}
        id="submit"
        text={getButtonText()}
        onClick={handleSubmit}
      />
      {isLoading && <ProgressLogo />}
      {/* Show any error or success messages */}
      {message && (
        <div className="error-message" id="payment-message">
          {message}
        </div>
      )}
    </form>
  );
}
